import type { CSSProperties } from 'react';

/**
 * Chrome values are inlined (not imported from @core/UI/skyx) on purpose:
 * this module is evaluated at chunk load time and importing across the
 * lobby/runtime chunk boundary caused a TDZ "cannot access before
 * initialization" error in the split production build.
 */
const CHROME_BORDER = '1px solid rgba(143,77,255,0.45)';
const CHROME_SHADOW =
  '0 0 24px rgba(179,71,255,0.18), 0 0 0 1px rgba(179,71,255,0.12) inset';
const OVERLAY_BG = 'rgba(20, 0, 51, 0.82)';
const OVERLAY_PADDING =
  'max(28px, calc(var(--headerHeightDynamic, 42px) + 12px)) 24px max(28px, env(safe-area-inset-bottom, 0px))';
const RADIUS_COMPACT = '20px';

const PANEL_BG = '#170550';
const HEADER_BG = '#9e54e3';
const TEXT = '#ffffff';

export const chatRulesModalStyles: Record<string, CSSProperties> = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: OVERLAY_BG,
    overflowX: 'visible',
    overflowY: 'auto',
    padding: OVERLAY_PADDING,
    zIndex: 10100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    fontFamily: "'Roboto', 'Inter', system-ui, sans-serif",
  },
  panel: {
    position: 'relative',
    border: CHROME_BORDER,
    boxShadow: CHROME_SHADOW,
    fontFamily: "'Roboto', sans-serif",
    width: '100%',
    maxWidth: '480px',
    background: PANEL_BG,
    borderRadius: RADIUS_COMPACT,
    color: TEXT,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
    backgroundColor: HEADER_BG,
  },
  title: {
    margin: 0,
    fontSize: '15px',
    fontWeight: 700,
    letterSpacing: '0.04em',
    color: TEXT,
    textTransform: 'uppercase',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: TEXT,
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    lineHeight: 1,
  },
  body: {
    background: PANEL_BG,
    padding: '20px 18px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  ruleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    textAlign: 'left',
  },
  ruleBullet: {
    flexShrink: 0,
    color: TEXT,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.45,
    marginTop: '1px',
  },
  ruleText: {
    margin: 0,
    color: TEXT,
    fontSize: '14px',
    lineHeight: 1.45,
    fontWeight: 400,
  },
};
